import { SensorsReportingStability, type SensorsSensorReportingSummary } from '@smarthome/api';

import { formatDurationShort } from '@/features/scenes/utils/duration';

export function formatReportingDuration(seconds?: number | null): string {
  if (seconds === undefined || seconds === null) {
    return '—';
  }
  return formatDurationShort(Math.max(0, Math.round(seconds)));
}

export function getReportingStabilityLabel(
  stability?: SensorsSensorReportingSummary['stability']
): string {
  switch (stability) {
    case SensorsReportingStability.ReportingStabilityStable:
      return 'Stable';
    case SensorsReportingStability.ReportingStabilityVariable:
      return 'Variable';
    case SensorsReportingStability.ReportingStabilityIrregular:
      return 'Irregular';
    default:
      return 'Insufficient data';
  }
}

export function getReportingStabilityTone(
  stability?: SensorsSensorReportingSummary['stability']
): string {
  switch (stability) {
    case SensorsReportingStability.ReportingStabilityStable:
      return 'text-emerald-600 dark:text-emerald-400';
    case SensorsReportingStability.ReportingStabilityVariable:
      return 'text-amber-600 dark:text-amber-400';
    case SensorsReportingStability.ReportingStabilityIrregular:
      return 'text-red-600 dark:text-red-400';
    default:
      return 'text-gray-500 dark:text-zinc-500';
  }
}
